import { jsx as _jsx } from "react/jsx-runtime";
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Bootstrap } from '../../components/bootstrap';
export const Route = createRootRoute({
    component: function RootComponent() {
        return _jsx(Bootstrap, { children: _jsx(Outlet, {}) });
    }
});
if (import.meta.hot) {
    import.meta.hot.accept(newModule => {
        if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
            newModule.Route.clone(Route);
        }
    });
}
